<app-header [isAlerts]="true"></app-header>
<ng-container *ngIf="vm$ | async as vm">
  <ion-content class="gray-content-bg">
    <ion-grid [fixed]="true">
      <ion-row *ngIf="isDesktop">
        <ion-col class="breadcrumb-spacing">
          <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
        </ion-col>
      </ion-row>
      <ion-row class="ion-align-items-center" *ngIf="isDesktop">
        <ion-col class="ion-no-padding">
          <div
            data-cy="title-notification-details"
            class="page-title-oswald"
            translate
          >
            {{ vm.notificationMetadata?.messageTitle }}
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <ng-container>
            <app-ordered-product-unavailable
              *ngIf="vm.notification?.alertId === '100051'"
              [notification]="vm.notification"
            >
            </app-ordered-product-unavailable>
            <app-delivery-issue
              *ngIf="vm.notification?.alertId === '100023'"
              [notification]="vm.notification"
              [notificationMetadata]="vm.notificationMetadata"
            >
            </app-delivery-issue>
          </ng-container>
        </ion-col>
      </ion-row>
    </ion-grid>
    <app-footer *ngIf="isDesktop"></app-footer>
  </ion-content>
</ng-container>
